import type { PublicProductQueryField } from "@/lib/productAggregates";

export interface PublicProductQuery {
  field: PublicProductQueryField;
  term: string;
}

const QUERY_FIELDS: PublicProductQueryField[] = ["sku", "name", "product_id"];

function decodeQueryValue(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, " ")).trim();
  } catch {
    return value.trim();
  }
}

/**
 * Read the single supported product query. Capturing the raw tail preserves a
 * literal `&amp;` in pasted name URLs as well as the normal `%26amp%3B` form.
 */
export function readPublicProductQuery(url: URL): PublicProductQuery | null {
  const rawSearch = url.search.replace(/^\?/, "");
  for (const field of QUERY_FIELDS) {
    const prefix = `${field}=`;
    if (rawSearch.startsWith(prefix)) {
      const term = decodeQueryValue(rawSearch.slice(prefix.length));
      return term ? { field, term } : null;
    }
  }

  const field = QUERY_FIELDS.find((candidate) => url.searchParams.has(candidate));
  const term = field ? url.searchParams.get(field)?.trim() || "" : "";
  return field && term ? { field, term } : null;
}
